export default __webpack_public_path__ + "static/media/premierepro.ee38e1aa.svg";